import { render, staticRenderFns } from "./ViewTeam.vue?vue&type=template&id=7ae05d44&scoped=true"
import script from "./ViewTeam.vue?vue&type=script&lang=js"
export * from "./ViewTeam.vue?vue&type=script&lang=js"
import style0 from "./ViewTeam.vue?vue&type=style&index=0&id=7ae05d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae05d44",
  null
  
)

export default component.exports